import React, { createContext, useContext, useState } from "react";

const sidebarContext = createContext();

export const useSidebar = () => useContext(sidebarContext);

export const SidebarProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    return (
        <sidebarContext.Provider value={{ isOpen, toggleSidebar }}>
            {children}
        </sidebarContext.Provider>
    );
};